import {
    TemplateBillingPricelistAbstractOverviewComponent,
    TemplateBillingPricelistAbstractOverviewController
} from '../abstract/pricelist-abstract-template';

export class TemplateBillingPricelistDatabasesOverviewController
    extends TemplateBillingPricelistAbstractOverviewController {
    protected options = {
        panelTitleTranslationId: /* translationId */ 'TR_090119-9211fc_TR',
        simpleFilterField: 'productName'
    };
}

export class TemplateBillingPricelistDatabasesOverviewComponent
    extends TemplateBillingPricelistAbstractOverviewComponent {
    public controller = TemplateBillingPricelistDatabasesOverviewController;
    public template = require('./pricelist-databases-template.html');
}
